import { IframeInvoicePreview } from "@/components/invoices/create-invoice-form/iframe-invoice-preview";
import { InvoiceFrequency, InvoicePaymentTerms } from "@/queries/invoice/types";

interface BusinessInfo {
  businessName: string;
  businessEmail: string;
  businessAddress: string;
  businessAddressLine2: string;
  businessCity: string;
  businessState: string;
  businessZip: string;
  hideAddress: boolean;
}

interface Branding {
  logo: string;
  brandColor: string;
  secondaryColor: string;
}

interface InvoicePreviewPanelProps {
  businessInfo: BusinessInfo;
  branding: Branding;
  logoPreview: string;
}

export const InvoicePreviewPanel = ({
  businessInfo,
  branding,
  logoPreview,
}: InvoicePreviewPanelProps) => {
  const defaultPreviewData = {
    status: "draft" as const,
    invoiceTo: {
      email: "customer@example.com",
      first_name: "John",
      last_name: "Doe",
      business_name: "Customer Company",
    },
    invoiceNumber: "INV-001",
    invoiceDate: undefined,
    dueDate: undefined,
    invoiceFrequency: InvoiceFrequency.ONE_TIME,
    invoiceFrequencyInterval: 0,
    invoiceExternalId: "",
    invoiceExternalIdLink: "",
    shippingFee: 0,
    taxPercentage: 0,
    lineItems: [
      {
        description: "Sample Item",
        quantity: 1,
        unit_price: 100,
        item_total: 100,
      },
    ],
    subtotal: 100,
    taxRate: 0,
    taxAmount: 0,
    total: 100,
    notes: "",
    terms: InvoicePaymentTerms.NET_30,
  };

  const getLogoUrl = (logoPath: string): string => {
    if (!logoPath) return "";
    if (logoPath.startsWith("http://") || logoPath.startsWith("https://")) {
      return logoPath;
    }
    return `https://cdn.pocketbook.tech/${logoPath}`;
  };

  return (
    <aside className="sticky top-8 col-span-2 shrink-0 hidden lg:block">
      <div className="overflow-hidden rounded-lg bg-gray-100 h-full">
        <div className="relative px-4 py-5 sm:p-6 2xl:p-10 h-full">
          <IframeInvoicePreview
            formData={defaultPreviewData}
            showZoomControls={false}
            businessInfoOverride={businessInfo}
            brandingOverride={{
              ...branding,
              logo: logoPreview || getLogoUrl(branding.logo),
            }}
          />
        </div>
      </div>
    </aside>
  );
};
